// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'localTime',
//   standalone: true
// })
// export class LocalTimePipe implements PipeTransform {
//     transform(value: string | Date | null | undefined, format: string = 'MMM d, y, h:mm a'): string {
//         if (!value) {
//             return '';
//         }

//         const date = value instanceof Date ? value : new Date(value + 'Z');
//         if (isNaN(date.getTime())) {
//             return '';
//         }

//         return new Intl.DateTimeFormat('en-US', {
//           year: 'numeric',
//           month: 'short',
//           day: 'numeric',
//           hour: 'numeric',
//           minute: 'numeric',
//           hour12: true,
//           timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
//         }).format(date);
//       }
// }


import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localTime',
  standalone: true
})
export class LocalTimePipe implements PipeTransform {
  transform(value: string | Date | null | undefined): string {
    if (!value) {
      return '';
    }

    let date: Date;

    if (value instanceof Date) {
      date = value;
    } else {
      // Clean up whitespace
      const trimmedValue = value.trim();
      
      // Check if the string already specifies UTC ('Z') or an explicit offset (+00:00, -05:00, etc.)
      const hasZoneOrOffset = /Z|[+-]\d{2}:?\d{2}$/i.test(trimmedValue);

      // If it doesn't have a zone/offset, append 'Z' to treat it as UTC. Otherwise, parse as-is.
      date = hasZoneOrOffset ? new Date(trimmedValue) : new Date(trimmedValue + 'Z');
    }

    if (isNaN(date.getTime())) {
      return '';
    }

    // Formats the date cleanly to the user's local browser timezone
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }).format(date);
  }
}